import { Say } from "../widgets/Say";
import { PlayUrl } from "./PlayUrl";

export function Nasals() {
  return (<>
    <h2>Nasals</h2>

    <ul>
      <li>
        nʲ:
        <Say>[ˈnʲːa ‖ aˈnʲːa]</Say> &nbsp;
        <Say>[['n:;a _. a'n:;a]]</Say> &nbsp;
      </li>
      <li>
        ɳ:
        <PlayUrl url="https://www.internationalphoneticassociation.org/IPAcharts/common_files/sounds/PL/0273.mp3" />&nbsp;
        <Say>[ˈɳːa ‖ aˈɳːa]</Say> &nbsp;
        <Say>[['n.:a _. a'n.:a]]</Say> &nbsp;
      </li>
      <li>
        ȵ:
        <Say>[ˈȵːa ‖ aˈȵːa]</Say> &nbsp;
        <Say>[['n:;a _. a'n:;a]]</Say> &nbsp;
      </li>
      <li>
        ɲ:
        <PlayUrl url="https://www.internationalphoneticassociation.org/IPAcharts/common_files/sounds/PL/0272.mp3" />&nbsp;
        <Say>[ˈɲːa ‖ aˈɲːa]</Say> &nbsp;
        <Say>[['n^:a _. a'n^:a]]</Say> &nbsp;
        - <Say>[['n:ja _. a'n:ja]]</Say>, <Say>[['nja _. a'nja]]</Say>
        <br />
        <Say>[ˈɲːa ‖ aˈɲːa]</Say>, <Say>[ˈɲːe ‖ eˈɲːe]</Say>, <Say>[ˈɲːi ‖ iˈɲːi]</Say>, <Say>[ˈɲːo ‖ oˈɲːo]</Say>, <Say>[ˈɲːu ‖ uˈɲːu]</Say>, <Say>[ˈɲːə ‖ əˈɲːə]</Say>
        <br />
        <Say>[ˈɲa ‖ aˈɲa]</Say>, <Say>[ˈɲe ‖ eˈɲe]</Say>, <Say>[ˈɲi ‖ iˈɲi]</Say>, <Say>[ˈɲo ‖ oˈɲo]</Say>, <Say>[ˈɲu ‖ uˈɲu]</Say>, <Say>[ˈɲə ‖ əˈɲə]</Say>
        <br />
        <Say>[['nja _. a'nja]]</Say>, <Say>[['nje _. e'nje]]</Say>, <Say>[['nji _. i'nji]]</Say>, <Say>[['njo _. o'njo]]</Say>, <Say>[['nju _. u'nju]]</Say>, <Say>[['njə _. ə'njə]]</Say>
      </li>
      <li>
        ŋ:
        <PlayUrl url="https://www.internationalphoneticassociation.org/IPAcharts/common_files/sounds/PL/014B.mp3" />
        <br />
        <Say>[ˈŋːa ‖ aˈŋːa]</Say>, <Say>[ˈŋːe ‖ eˈŋːe]</Say>, <Say>[ˈŋːi ‖ iˈŋːi]</Say>, <Say>[ˈŋːo ‖ oˈŋːo]</Say>, <Say>[ˈŋːu ‖ uˈŋːu]</Say>, <Say>[ˈŋːə ‖ əˈŋːə]</Say>
      </li>
    </ul>
  </>);
}
